import gsap from "gsap";

export class W3ErrorPage {
  private numbers: NodeListOf<HTMLElement>;
  private numberOne: Element;
  private numberTwo: Element;
  private numberThree: Element;
  private title: HTMLElement | null;
  private button: HTMLElement | null;

  constructor() {
    document.addEventListener("DOMContentLoaded", () => {
      if (!document.querySelector(".error-page")) return;
      this.numberOne = document.querySelector(".error__number.number-1");
      this.numberTwo = document.querySelector(".error__number.number-2");
      this.numberThree = document.querySelector(".error__number.number-3");
      this.title = document.querySelector(".error__title");
      this.button = document.querySelector(".error__button");
      this.animateNumbers();
    });
  }

  private animateNumbers(): void {
    //width of numberTwo
    const widthOfZero = this.numberTwo.clientWidth;
    console.log(widthOfZero);
    console.log(this.numberTwo);

    if (window.innerWidth > 1024) {
      gsap.to(
        this.numberOne,
        {
          duration: 2,
          fontSize: 400,
          left: "calc(50% - " + widthOfZero + "px)",
          top: "50%",
          ease: "power4.out",
          transform: "rotate(-360deg) translate(-50%, -50%)",
        },
        0.25,
      );

      gsap.to(this.numberTwo, {
        duration: 2,
        fontSize: 400,
        ease: "power4.out",
        transform: "rotate(-360deg) translate(-50%, -50%)",
      });

      gsap.to(
        this.numberThree,
        {
          duration: 2,
          fontSize: 400,
          left: "calc(50% + " + widthOfZero + "px)",
          top: "50%",
          ease: "power4.out",
          transform: "rotate(-360deg) translate(-50%, -50%)",
        },
        1.5,
      );

      gsap.to(
        this.title,
        {
          top: "10%",
          duration: 2,
          opacity: 1,
          ease: "power4.out",
        },
        2.5,
      );

      gsap.to(
        this.button,
        {
          top: "80%",
          duration: 2,
          opacity: 1,
          ease: "power4.out",
        },
        1,
      );
    }
  }
}
